export default __webpack_public_path__ + "static/api-a415a0bb9dae1b3da2482256f8ac3647.png";